import { render, staticRenderFns } from "./PickFeedback.vue?vue&type=template&id=b57af57c&scoped=true"
import script from "./PickFeedback.vue?vue&type=script&lang=js"
export * from "./PickFeedback.vue?vue&type=script&lang=js"
import style0 from "./PickFeedback.vue?vue&type=style&index=0&id=b57af57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57af57c",
  null
  
)

export default component.exports